import React from 'react';
import { Pagination } from 'react-bootstrap';
import styled from 'styled-components';

const SearchPaginationContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  margin: 1em 0;

  .page-link {
    min-width: 48px;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: rgba(3, 7, 18, 0.72) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    color: #e2e8f0 !important;
    border-radius: 2px;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    box-shadow: none;
  }

  .page-link:hover {
    background: rgba(15, 23, 42, 0.9) !important;
    color: #f8fafc !important;
    border-color: rgba(148, 163, 184, 0.35) !important;
  }

  .page-item.disabled .page-link {
    background: rgba(3, 7, 18, 0.72) !important;
    border-color: rgba(255, 255, 255, 0.08) !important;
    color: #64748b !important;
    opacity: 1;
  }

  .pagination {
    justify-content: center;
    gap: 10px;
    margin-bottom: 0;
  }
`;

interface ISearchPaginationProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
  isFirstPage: boolean;
  isLastPage: boolean;
  isDisabled: boolean;
  totalRecords?: number;
  facilitiesCount?: number;
}

const TotalRecordTextContainer = styled.div`
  margin: 1em 0 0;
  color: #7c8b9f;
  text-align: center;
`;

const SearchPagination: React.FC<ISearchPaginationProps> = (props) => {
  return (
    <SearchPaginationContainer>
      <Pagination size="lg">
        <Pagination.First disabled={props.isFirstPage || props.isDisabled} onClick={props.onPreviousClick} />
        <Pagination.Last disabled={props.isLastPage || props.isDisabled} onClick={props.onNextClick} />
      </Pagination>
      {typeof props.totalRecords === 'number' && (
        <TotalRecordTextContainer>
          About <b>{props.totalRecords}</b> documents
          {typeof props.facilitiesCount === 'number' ? ` from ${props.facilitiesCount} facilities` : ''}
        </TotalRecordTextContainer>
      )}
    </SearchPaginationContainer>
  );
};

export default SearchPagination;
